/**
 * Parse a 1–5 slider rating from free-text user input.
 * @param {string} text
 * @returns {number|null}
 */
export function parseRatingFromMessage(text) {
  if (!text || typeof text !== 'string') return null;
  const trimmed = text.trim();
  if (!trimmed) return null;

  const direct = trimmed.match(/^([1-5])$/);
  if (direct) return Number(direct[1]);

  const arrow = trimmed.match(/(?:->|→|:|=)\s*([1-5])\b/);
  if (arrow) return Number(arrow[1]);

  const fraction = trimmed.match(/\b([1-5])\s*\/\s*5\b/);
  if (fraction) return Number(fraction[1]);

  const vonBis = trimmed.match(/(?:von\s*)?[1-5]\s*[-–]\s*5\s*(?:->|→|:|=)?\s*([1-5])\b/i);
  if (vonBis) return Number(vonBis[1]);

  const ratingWord = trimmed.match(/\b(?:rating|score|wert|note|stimme)\s*([1-5])\b/i);
  if (ratingWord) return Number(ratingWord[1]);

  return null;
}

/**
 * Detect short confirmation intent (save & continue).
 * @param {string} text
 * @returns {boolean}
 */
export function isConfirmIntent(text) {
  if (!text || typeof text !== 'string') return false;
  const t = text.trim().toLowerCase();
  if (!t) return false;
  return /^(yes|ja|ok|okay|confirm|bestätigen|bestaetigen|weiter|next|go|passt|stimmt|yes confirm|ja passt)$/.test(t)
    || /\b(confirm|bestätigen|bestaetigen)\b/.test(t);
}
